import React from 'react';

export function FormSuccess() {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
      <span className="text-4xl">✅</span>
      <p className="text-royal-500 text-sm font-semibold">
        Your submission has been received. Thank you!
      </p>
    </div>
  );
}
